import { useNavigate } from 'react-router-dom';
import { isAdminUser } from '../../config/environment';
import { useAuth } from '../../context/Auth/AuthContext';

import styles from './Footer.module.css';

const Footer = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  return (
    <footer className={styles.footer}>
      <p>© 2025 Kingdom Studio. All rights reserved.</p>
      <div className={styles.footerLinks}>
        <button 
          onClick={() => navigate('/privacy-policy')} 
          className={styles.footerLink}
        >
          Privacy Policy
        </button>
        <span className={styles.footerDivider}>|</span>
        <button 
          onClick={() => navigate('/terms-of-service')} 
          className={styles.footerLink}
        >
          Terms of Service
        </button>
        {isAdminUser(user) && (
          <>
            <span className={styles.footerDivider}>|</span>
            <button 
              onClick={() => navigate('/affiliate')} 
              className={styles.footerLink}
            >
              Affiliate Program
            </button>
          </>
        )}
        <span className={styles.footerDivider}>|</span>
        <a 
          href="mailto:info@kingdomstudio.pro" 
          className={styles.footerLink}
        >
          Contact Support
        </a>
      </div>
    </footer>
  );
};

export default Footer;
